/**
 * Controllo genitori: un interruttore, non una scala.
 *
 * ────────────────────────────────────────────────────────────────────────────────
 * ATTENZIONE — QUESTA È L'UNICA DELLE CINQUE REGOLE DEL PROTOTIPO v3 CHE **NON** È
 * STATA PORTATA PARI PARI, E NON POTEVA ESSERLO.
 *
 * Il prototipo scrive:
 *
 *     locked(v) { const R = { T: 0, '12+': 12, '14+': 14, '16+': 16, '18+': 18 };
 *                 return !!this.state.pin && R[v.r] >= R[this.state.adult]; }
 *
 * cioè una **scala d'età** con una soglia configurabile. La decisione D-6 l'ha
 * cancellata, e due documenti la dichiarano morta a chiare lettere: 02-ACCESSO §8
 * («Niente fasce d'età: nessun `T/12+/14+/16+/18+`, nessuna soglia configurabile») e
 * 05-CONTRATTO-API §9 («Niente `minAge`, niente normalizzatore di scale»). La ragione
 * scritta è che una soglia funzionerebbe sulla parte di catalogo che ha una
 * classificazione e non sull'altra, e una soglia che copre metà catalogo è peggio di
 * nessuna soglia — un genitore la imposta e si fida.
 *
 * Quindi qui la regola è: **PIN impostato e contenuto marcato per adulti**. Il campo
 * `is_adult` arriva già risolto dentro la lista, con l'eredità dal bouquet applicata dal
 * backend (vince il più restrittivo).
 *
 * Questa divergenza è segnalata nel rapporto della sessione e va confermata da un umano.
 * ────────────────────────────────────────────────────────────────────────────────
 */

export interface ParentalSettings {
  /** Il PIN a 4 cifre è impostato su questo apparecchio. Locale, non recuperabile. */
  readonly pinEnabled: boolean;
}

export interface AdultFlagged {
  readonly isAdult: boolean;
}

/** `locked` del prototipo, senza la scala d'età. */
export function isLocked(item: AdultFlagged, settings: ParentalSettings): boolean {
  return settings.pinEnabled && item.isAdult;
}

export const PIN_LENGTH = 4;

export type PinCheck = 'accepted' | 'rejected' | 'incomplete';

/**
 * Il PIN sbagliato non porta via dalla schermata: si svuotano i pallini, compare «PIN
 * errato. Riprova.», e **l'azione resta in attesa**. Quando il PIN è giusto l'azione
 * parte da sé, non va rifatta (02-ACCESSO §8, punto 2).
 */
export function checkPin(entered: string, stored: string): PinCheck {
  if (entered.length < PIN_LENGTH) return 'incomplete';
  return entered === stored ? 'accepted' : 'rejected';
}
